export const SpinnerSizeValues = {
  Small: 'sm',
  Medium: 'md',
  Large: 'lg',
} as const;

export type SpinnerSize = typeof SpinnerSizeValues[keyof typeof SpinnerSizeValues];

const sizeClasses: Record<SpinnerSize, string> = {
  [SpinnerSizeValues.Small]: 'h-5 w-5 border-2', // 20px
  [SpinnerSizeValues.Medium]: 'h-10 w-10 border-4', // 40px
  [SpinnerSizeValues.Large]: 'h-20 w-20 border-8', // 80px
};

export default function LoadingSpinner({ size = SpinnerSizeValues.Medium }: Readonly<{ size?: SpinnerSize }>) {
  return (
    <div aria-hidden className={`${sizeClasses[size]} animate-spin rounded-full border-gray-300 border-t-blue-600`} />
  );
}
